import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CrewMerchantUi } from 'corso-types';
import { match } from 'ts-pattern';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useShippingClaimLineItemDelete() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      lineItem: CrewMerchantUi.ShippingClaim['shippingClaimLineItems'][number],
    ) => {
      const claim = api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`);

      return match(lineItem)
        .with({ kind: 'line_item' }, ({ id }) => claim.lineItem.delete(`${id}`))
        .with({ kind: 'replacement_item' }, ({ id }) =>
          claim.replacementItem.delete(id),
        )
        .exhaustive();
    },
    // the inventory modal reads its own query, so it goes stale on any line item change
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      });
      await queryClient.invalidateQueries({
        queryKey: ['shippingClaimInventoryLevels', shippingClaim.id, storeId],
      });
    },
  });
}
